/** True when the merchant has a default payment (PSP) credential id. Matches MMS predicate. */
export function merchantHasDefaultPaymentCredential(
  merchant?: {
    externalCredentials?: Partial<Record<string, string | null | undefined>> | null;
  } | null,
): boolean {
  const paymentCredentialId = merchant?.externalCredentials?.payment;
  return typeof paymentCredentialId === 'string' && paymentCredentialId.trim().length > 0;
}
